module.exports = __webpack_public_path__ + "media/images/good_star-b2adec84fd9131eaa1790258f7716aec.svg";